/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import { CustomerContactDtoModel } from '../customer-contact-dto.model';

export class OpportunityContactDtoModel extends JSONable {
  customerContactDto: CustomerContactDtoModel | undefined = undefined;
  opportunityUuid: string | undefined = undefined;
  uuid: string | undefined = undefined;
}
